{
  "Audio Player": "Player Audio",
  "Video Player": "Player Video",
  "Play": "Play",
  "Pause": "Pausa",
  "Replay": "Ripetere",
  "Current Time": "Tempo attuale",
  "Duration": "Durata",
  "Remaining Time": "Tempo rimanente",
  "Stream Type": "Tipo di Streaming",
  "LIVE": "LIVE",
  "Loaded": "Caricato",
  "Progress": "Stato",
  "Progress Bar": "Barra di stato",
  "progress bar timing: currentTime={1} duration={2}": "{1} di {2}",
  "Fullscreen": "Schermo intero",
  "Non-Fullscreen": "Chiudi schermo intero",
  "Mute": "Muto",
  "Unmute": "Riattiva audio",
  "Playback Rate": "Tasso di riproduzione",
  "Subtitles": "Sottotitoli",
  "subtitles off": "Senza sottotitoli",
  "Captions": "Sottotitoli non udenti",
  "captions off": "Senza sottotitoli non udenti",
  "Chapters": "Capitolo",
  "Descriptions": "Descrizioni",
  "descriptions off": "descrizioni disattivate",
  "Audio Track": "Tracce audio",
  "Volume Level": "Livello del volume",
  "You aborted the media playback": "La riproduzione del filmato è stata interrotta.",
  "A network error caused the media download to fail part-way.": "Il download del filmato è stato interrotto a causa di un problema rete.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.",
  "No compatible source was found for this media.": "Non ci sono fonti compatibili per questo filmato.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Questo media è protetto.",
  "Play Video": "Mostra il video",
  "Close": "Chiudi",
  "Close Modal Dialog": "Chiudi la finestra di dialogo modale",
  "Modal Window": "Finestra modale",
  "This is a modal window": "Questa è una finestra modale",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Questa modale può essere chiusa premendo il tasto Esc o attivando il pulsante Chiudi.",
  ", opens captions settings dialog": ", apre la finestra di dialogo delle impostazioni delle didascalie",
  ", opens subtitles settings dialog": ", apre la finestra di dialogo delle impostazioni dei sottotitoli",
  ", opens descriptions settings dialog": ", apre la finestra di dialogo delle impostazioni delle descrizioni",
  ", selected": ", selezionato",
  "captions settings": "impostazioni delle didascalie",
  "subtitles settings": "impostazioni dei sottotitoli",
  "descriptions settings": "impostazioni delle descrizioni",
  "Text": "Testo",
  "White": "Bianco",
  "Black": "Nero",
  "Red": "Rosso",
  "Green": "Verde",
  "Blue": "Blu",
  "Yellow": "Giallo",
  "Magenta": "Magenta",
  "Cyan": "Ciano",
  "Background": "Sfondo",
  "Window": "Finestra",
  "Transparent": "Trasparente",
  "Semi-Transparent": "Semi trasparente",
  "Opaque": "Opaco",
  "Font Size": "Dimensione del font",
  "Text Edge Style": "Stile bordo testo",
  "None": "Nessuna",
  "Raised": "Sollevato",
  "Depressed": "Premuto",
  "Uniform": "Uniforme",
  "Dropshadow": "Ombra",
  "Font Family": "Famiglia di font",
  "Proportional Sans-Serif": "Sans-Serif proporzionale",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Serif proporzionale",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casuale",
  "Script": "Script",
  "Small Caps": "Maiuscoletto",
  "Reset": "Ripristina",
  "restore all settings to the default values": "ripristinare tutte le impostazioni ai valori predefiniti",
  "Done": "Fatto",
  "Caption Settings Dialog": "Finestra di dialogo Impostazioni didascalia",
  "Beginning of dialog window. Escape will cancel and close the window.": "Inizio della finestra di dialogo. Escape annulla e chiude la finestra.",
  "End of dialog window.": "Fine della finestra di dialogo.",
  "ISO-639-1": "it",
  "10 seconds backward": "Riavvolgere 10 secondi",
  "30 seconds forward": "Avanzare 30 secondi",
  "Audio": "Audio",
  "Audio and subtitles": "Audio e sottotitoli",
  "Audio Description": "Audiodescrizione",
  "Auto play": "Auto play",
  "Back": "Indietro",
  "Casting to": "Play su Chromecast",
  "Content will be available in {1} days": "Disponibile fra {1} giorni",
  "Current position": "Posizione attuale",
  "Current subject": "Servizio attuale",
  "Days": "Giorni",
  "Duration: {1}": "Durata: {1}",
  "Edit player settings": "Modificare le impostazioni del lettore",
  "Episode": "Episodio",
  "HD": "HD",
  "Continuous Playback": "Play continuo",
  "Cancel": "Annulla",
  "Coming next": "Prossimo",
  "Copied": "Copiato",
  "copy": "copia",
  "Copy debug info": "Copia le informazioni di debug",
  "Copy link": "Copia link",
  "Facebook": "Facebook",
  "Font size level {1}": "Dimensione carattere {1}",
  "Hours": "Ore",
  "Integrate": "Integrare",
  "Issue:": "Problema:",
  "LinkedIn": "LinkedIn",
  "Mail": "Email",
  "Minutes": "Minuti",
  "Off": "Disattivati",
  "Open {1} in Play {2}": "Aprire {1} in Play {2}",
  "Playback will begin shortly": "La riproduzione inizierà a breve",
  "Please indicate the problem below, so that we can help you:": "Si prega di specificare il problema qui sotto in modo che possiamo aiutarvi :",
  "Quality": "Qualità",
  "Report a technical problem": "Segnala un problema tecnico",
  "SD": "SD",
  "Seconds": "Secondi",
  "Seek to live, currently behind live": "Torna alla diretta, attualmente prima della diretta",
  "Seek to live, currently playing live": "Torna alla diretta, attualmente in onda la diretta",
  "Send bug report": "Segnala bug",
  "Share at current position": "Condividere dalla posizione attuale",
  "Share by e-mail": "Condividi via email",
  "Share": "Condividere",
  "Share on {1}": "Pubblicare su {1}",
  "Share on Facebook": "Pubblicare su Facebook",
  "Share on Linkedin": "Pubblicare su Linkedin",
  "Share on Twitter": "Pubblicare su Twitter",
  "Share on Whatsapp": "Pubblicare su Whatsapp",
  "Share on X": "Pubblicare su X",
  "Share the current subject": "Condividere il servizio attuale",
  "Share the episode": "Condividere l'episodio",
  "Skip credits": "Salta i credits",
  "Skip intro": "Salta l'intro",
  "Speed": "Velocità di riproduzione",
  "Start casting": "Play su Chromecast",
  "Start pip": "Passare a Picture in Picture",
  "Stop": "Stop",
  "Stop casting": "Stop play su Chromecast",
  "Stop pip": "Smettere di Picture in Picture",
  "The content cannot be played.": "Il contenuto non può essere riprodotto.",
  "This content cannot be played while using a VPN.": "Questo contenuto non può essere riprodotto mentre si utilizza una VPN.",
  "The content was skipped due to legal restriction": "Il contenuto non è fruibile a causa di restrizioni legali",
  "This content is temporarily unavailable for journalistic reasons.": "Questo contenuto è temporaneamente non disponibile per motivi editoriali.",
  "This commercial media is not available.": "Questo contenuto commerciale non è disponibile.",
  "This content is not available.": "Questo media non è disponibile.",
  "This content is not available anymore.": "Questo media non è più disponibile.",
  "This content is not available due to legal restrictions.": "Il contenuto non è fruibile a causa di restrizioni legali.",
  "This content is not available outside Switzerland.": "Questo media non è disponibile fuori dalla Svizzera.",
  "This content is not yet available. Please try again later.": "Il contenuto non è ancora disponibile. Per cortesia prova più tardi.",
  "To protect children, this content is only available between 8PM and 6AM.": "Per proteggere i bambini, questo media è disponibile solo fra le 20 e le 6.",
  "To protect children, this content is only available between 11PM and 5AM.": "Per proteggere i bambini, questo media è disponibile solo fra le 23 le 5.",
  "Twitter": "Twitter",
  "Unable to display the content. For more information and help, click here...": "Siamo spiacenti. Il contenuto desiderato non può essere riprodotto. Per maggiori informazioni e assistenza cliccare qui.",
  "Unfortunately the 360 playback experience is not compatible with your browser version.": "Sfortunatamente il suo browser non è compatibile con la visualizzazione a 360 gradi.",
  "Unfortunately this format is not compatible with your browser.": "Purtroppo il formato non è compatibile con il suo browser.",
  "WhatsApp": "WhatsApp",
  "X": "X"
}
